<div id="value-added-courses" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Skill / Value Added Courses</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College, Sirsa offers a variety of Skill and Value Added Courses to enhance the
      employability, practical skills and holistic development of students beyond the regular curriculum. These courses
      are designed to bridge the gap between academic learning and industry requirements.
    </p>

    <hr class="divider">

    <!-- NOTE: Upload value added courses PDF to: src/assets/pdf/academics/value-added-courses.pdf -->
    <div class="pdf-block">
      <img src="/assets/img/academics/Skill-oriented-courses.png" alt="Value Added Courses"
        class="img-fluid img-rounded-shadow" style="width:100%; height:680px; display:block;">

    </div>

    <div class="mt-3">
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSdZd8l-FA-DFB1C2fWz9OLhFzHjBM2bFb-hZXUJKDE0shHEMw/viewform"
        target="_blank" class="pdf-download-btn">
        <i class="fa fa-download"></i> Registration
      </a>
    </div>

  </div>
</div>